import { UserRole } from "@decentriq/graphql/dist/types";

export const userRolePresentation = new Map<UserRole, string>([
  [UserRole.NormalUser, "User"],
  [UserRole.SuperAdmin, "Decentriq Admin"],
  [UserRole.SuperAdminReadOnly, "Decentriq Admin Read-Only"],
  [UserRole.OrganizationAdmin, "Organization Admin"],
]);
